// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-hJj","controls":"styles_controls__s1pYX","charLimit":"styles_charLimit__2UgvA","input":"styles_input__3-T_V","send":"styles_send__-Io-t"};